import Icon from '../../../components/AppIcon';

const SecuritySection = () => {
  const securityFeatures = [
    {
      id: 'interview',
      icon: 'UserCheck',
      title: 'Тест на 7 каналов коммуникации',
      description: 'Первый шаг — пройти тест. На его основе создаётся ваш цифровой двойник.'
    },
    {
      id: 'ai-verification',
      icon: 'Shield',
      title: 'Цифровой двойник работает за вас',
      description: 'Ваш двойник автоматически проводит тысячи виртуальных свиданий, проверяя совместимость по социальной инженерии.'
    },
    {
      id: 'no-fakes',
      icon: 'CheckCircle',
      title: 'Только готовые результаты',
      description: 'Вы не получаете доступ к анкетам. Вы получаете лучший результат тысяч свиданий вашего цифрового двойника.'
    },
    {
      id: 'active-search',
      icon: 'Clock',
      title: 'Непрерывный автоматический поиск',
      description: 'Цифровой двойник работает 24/7, пока вы живёте обычной жизнью. Вы получаете уведомления о совпадениях.'
    }
  ];

  return (
    <section id="security" className="py-20 sm:py-32 bg-gradient-to-br from-primary/5 to-background">
      <div className="max-w-content mx-auto px-4 sm:px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary/10 rounded-full text-primary text-sm font-medium mb-6">
            <Icon name="Shield" size={16} />
            <span>Безопасность превыше всего</span>
          </div>

          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-6">
            Технология цифровых двойников
          </h2>

          <p className="text-lg text-secondary max-w-3xl mx-auto">
            Первый полностью автоматизированный сервис на основе социальной инженерии, ИИ и цифровых двойников. 
            Вы не выбираете анкеты — вы получаете результаты тысяч виртуальных свиданий.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {securityFeatures.map((feature) => (
            <div
              key={feature.id}
              className="bg-card rounded-2xl p-8 border border-border hover:border-primary transition-all duration-300 hover:shadow-lg"
            >
              <div className="flex items-start gap-4">
                <div className="w-14 h-14 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <Icon name={feature.icon as any} size={28} color="var(--color-primary)" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-foreground mb-3">
                    {feature.title}
                  </h3>
                  <p className="text-secondary leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <div className="inline-flex items-center gap-3 px-6 py-4 bg-primary/10 rounded-xl border border-primary/20">
            <Icon name="Users" size={24} color="var(--color-primary)" />
            <div className="text-left">
              <div className="text-sm text-secondary">Цифровых двойников работает прямо сейчас</div>
              <div className="text-2xl font-bold text-primary">247 двойников</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SecuritySection;